const routes = [{
  path: '/index',
  name: 'Index',
  component: () =>
    import('@/views/Index'),
  meta: {
    tabbar: true,
    title: '首页'
  },
  children: [{
    path: '/404',
    name: 'NotFound',
    component: () =>
      import('@/views/404'),
    meta: {
      tabbar: true,
      title: 'not found'
    }
  }, {
    path: '/user/index',
    name: 'UserIndex',
    component: () =>
      import('@/views/user/Index'),
    meta: {
      tabbar: true,
      title: '用户'
    }
  }, {
    path: '/cost/index',
    name: 'CostIndex',
    component: () =>
      import('@/views/cost/Index'),
    meta: {
      tabbar: true,
      title: '扣费'
    }
  }, {
    path: '/task/index',
    name: 'TaskIndex',
    component: () =>
      import('@/views/task/Index'),
    meta: {
      tabbar: true,
      title: '任务'
    }
  }, {
    path: '/task/detail',
    name: 'TaskDetail',
    component: () =>
      import('@/views/task/Detail'),
    meta: {
      title: '任务详情'
    }
  }, {
    path: '/task/ftp',
    name: 'TaskFtp',
    component: () =>
      import('@/views/task/Ftp'),
    meta: {
      title: 'ftp/后台'
    }
  }, {
    path: '/task/prestore',
    name: 'TaskPrestore',
    component: () =>
      import('@/views/task/Prestore'),
    meta: {
      title: '续预存费'
    }
  }, {
    path: '/user/account_setting',
    name: 'AccountSetting',
    component: () =>
      import('@/views/user/AccountSetting'),
    meta: {
      title: '账号设置'
    }
  }, {
    path: '/user/auth',
    name: 'Auth',
    component: () =>
      import('@/views/user/Auth'),
    meta: {
      title: '实名认证'
    }
  }, {
    path: '/task/service_charge',
    name: 'TaskServiceCharge',
    component: () =>
      import('@/views/task/ServiceCharge'),
    meta: {
      title: '续服务费'
    }
  }, {
    path: '/user/modify_password',
    name: 'ModifyPassword',
    component: () =>
      import('@/views/user/ModifyPassword'),
    meta: {
      title: '修改密码'
    }
  }, {
    path: '/user/recharge',
    name: 'Recharge',
    component: () =>
      import('@/views/user/Recharge'),
    meta: {
      title: '充值'
    }
  }, {
    path: '/task/recharge-success',
    name: 'RechargeSuccess',
    component: () =>
      import('@/views/task/RechargeSuccess'),
    meta: {
      title: '充值成功'
    }
  }, {
    path: '/user/recharge_detail',
    name: 'RechargeDetail',
    component: () =>
      import('@/views/user/RechargeDetail'),
    meta: {
      title: '查看明细'
    }
  }, {
    path: '/user/coupon',
    name: 'Coupon',
    component: () =>
      import('@/views/user/Coupon'),
    meta: {
      title: '优惠券'
    }
  }, {
    path: '/user/news',
    name: 'News',
    component: () =>
      import('@/views/user/News'),
    meta: {
      title: '我的消息'
    }
  }, {
    path: '/user/news/:id',
    name: 'NewsDetail',
    component: () =>
      import('@/views/user/NewsDetail'),
    meta: {
      title: '消息详情'
    }
  }, {
    path: '/user/order',
    name: 'Order',
    component: () =>
      import('@/views/user/Order'),
    meta: {
      title: '我的工单'
    }
  }, {
    path: '/user/bind_mobile',
    name: 'BindMobile',
    component: () =>
      import('@/views/user/BindMobile'),
    meta: {
      title: '手机绑定'
    }
  }, {
    path: '/pay/recharge',
    name: 'PayRecharge',
    component: () =>
      import('@/views/pay/PayRecharge'),
    meta: {
      title: '支付'
    }
  }, {
    path: '/task/keyword',
    name: 'TaskKeyword',
    component: () =>
      import('@/views/task/Keyword'),
    meta: {
      title: '关键词'
    }
  }, {
    path: '/task/keyword_cost',
    name: 'TaskKeywordCost',
    component: () =>
      import('@/views/task/KeywordCost'),
    meta: {
      title: '关键词'
    }
  }, {
    path: '/task/publish_first',
    name: 'PublishFirst',
    component: () =>
      import('@/views/task/PublishFirst'),
    meta: {
      title: '按天任务'
    }
  }, {
    path: '/task/publish_second',
    name: 'PublishSecond',
    component: () =>
      import('@/views/task/PublishSecond'),
    meta: {
      title: '添加关键词'
    }
  }, {
    path: '/task/publish_third',
    name: 'PublishThird',
    component: () =>
      import('@/views/task/PublishThird'),
    meta: {
      title: '订单确认'
    }
  }, {
    path: '/task/task_pay',
    name: 'TaskPay',
    component: () =>
      import('@/views/task/TaskPay'),
    meta: {
      title: '支付'
    }
  }, {
    path: '/task/publish_success',
    name: 'PublishSuccess',
    component: () =>
      import('@/views/task/PublishSuccess'),
    meta: {
      title: '支付'
    }
  }, {
    path: '/invite/invite',
    name: 'Invite',
    component: () =>
      import('@/views/invite/Invite'),
    meta: {
      title: '邀请加词'
    }
  }, {
    path: '/invite/been_invited',
    name: 'BeenInvited',
    component: () =>
      import('@/views/invite/BeenInvited'),
    meta: {
      title: '受邀加词'
    }
  }, {
    path: '/invite/add_word',
    name: 'InviteAddWord',
    component: () =>
      import('@/views/invite/AddWord'),
    meta: {
      title: '受邀加词申请'
    }
  }, {
    path: '/share/coupon',
    name: 'ShareCoupon',
    component: () =>
      import('@/views/share/Coupon'),
    meta: {
      title: '分享优惠券'
    }
  }, {
    path: '/task/show-off',
    name: 'ShowOff',
    component: () =>
      import('@/views/task/ShowOff'),
    meta: {
      title: '炫耀一下'
    }
  }, {
    path: '/task/show-off2',
    name: 'ShowOff2',
    component: () =>
      import('@/views/task/ShowOff2'),
    meta: {
      title: '炫耀一下'
    }
  }, {
    path: '/task/apply-addword',
    name: 'ApplyAddWord',
    component: () =>
      import('@/views/task/ApplyAddWord'),
    meta: {
      title: '申请加词'
    }
  }, {
    path: '/task/addword-success',
    name: 'AddWordSuccess',
    component: () =>
      import('@/views/task/AddWordSuccess'),
    meta: {
      title: '加词成功'
    }
  }]
}, {
  path: '/login',
  name: 'Login',
  component: () =>
    import('@/views/Login'),
  meta: {
    title: '登录'
  }
}, {
  path: '/jump',
  name: 'Jump',
  component: () =>
    import('@/views/jump'),
  meta: {
    title: 'jump'
  }
}, {
  path: '*',
  redirect: '/user/index'
}]

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js